<template>
  <VCard
      class="p-0 shadow-none border-radius-8 px-4 py-4"
  >
    <VCardTitle class="p-0 d-flex justify-content-between align-center position-relative">
      <div>
        <span class="heading-6">
          {{ caption }}
        </span>
      </div>
      <VBtn
          icon
          color="textPrimary"
          @click="$emit('closeDialog')"
      >
        <VIcon>mdi-close</VIcon>
      </VBtn>
    </VCardTitle>
    <VCardText class="p-0 pt-6">
      <div class="d-flex align-items-center justify-content-center">
        <img
            :src="require('@slg/web-customer-shared/src/assets/img/CheckCircle.svg')"
            :alt="$t('imageAlt.successCheckmark')"
        >
      </div>
      <div class="card-text-body pt-6">
        <span class="body-1">
          {{ body }}
        </span>
      </div>
    </VCardText>
    <VCardActions class="px-0 pb-0 pt-4">
      <VBtn
          v-blur
          class="w-100 body-2 border-radius-8"
          dark
          large
          color="brandingPrimary"
          @click="$emit('closeDialog')"
      >
        {{ $t('general.ok') }}
      </VBtn>
    </VCardActions>
  </VCard>
</template>

<script lang="ts">
export default {
  name: 'SuccessDialog',
};
</script>

<script setup lang="ts">
defineProps({
  caption: {
    type: String,
    default: '',
  },
  body: {
    type: String,
    default: '',
  },
});
</script>
